import type { ThumbPoint } from '@boatnav/core';

const W = 74;
const H = 56;
const PAD = 6;

/** Tiny inline SVG polyline from the stored 0..1 thumbnail path (spec 03). */
export function TrackThumb({ path }: { path: ThumbPoint[] }): JSX.Element {
  const points = path
    .map((p) => `${(PAD + p.x * (W - 2 * PAD)).toFixed(1)},${(PAD + p.y * (H - 2 * PAD)).toFixed(1)}`)
    .join(' ');

  return (
    <svg className="thumb" viewBox={`0 0 ${W} ${H}`} width={W} height={H} aria-hidden="true">
      {path.length > 1 && (
        <polyline
          points={points}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
